<template>
    <a
        class="dm-pointer"
        v-if="contact_details && contact_details.can_view_author_contact_details"
        @click.prevent="openAuthorContactDetailsModal()"
    >
        <span class="svg-icon svg-icon-md svg-icon-dark-75 mr-1">
            <PersonSvg />
        </span>
        {{ contact_details.author_names }}
    </a>

    <span v-else>
        <span class="svg-icon svg-icon-md svg-icon-dark-75 mr-1">
            <PersonSvg />
        </span>
        {{ contact_details.author_names }}
    </span>

    <modal
        size="md"
        class="text-left dm-modal dm-author-contact-details-modal"
        v-if="contact_details && contact_details.can_view_author_contact_details"
        :id="'dm-author-contact-details-modal-' + submission_id"
        :title="translate('Author Contact Details')"
    >
        <table class="table">
            <tbody>
                <tr v-if="contact_details.author_names">
                    <th
                        scope="row"
                        class="border-0"
                    >
                        {{ translate("Author Names") }}
                    </th>
                    <td class="border-0 font-weight-normal">
                        {{ contact_details.author_names }}
                    </td>
                </tr>
                <tr v-else>
                    <th
                        scope="row"
                        class="border-0"
                    >
                        {{ translate("Full Name") }}
                    </th>
                    <td class="border-0 font-weight-normal">
                        {{ contact_details.name }}
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ translate("Email") }}</th>
                    <td class="font-weight-normal">
                        {{ contact_details.email }}
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ translate("Phone") }}</th>
                    <td class="font-weight-normal">
                        {{ contact_details.phone }}
                    </td>
                </tr>

                <tr v-if="contact_details.website">
                    <th scope="row">{{ translate("Website") }}</th>
                    <td class="font-weight-normal">
                        <a
                            :href="contact_details.website"
                            target="_blank"
                        >{{ contact_details.website }}
                            <i class="las la-external-link-alt"></i></a>
                    </td>
                </tr>
                <tr v-if="contact_details.instagram">
                    <th scope="row">{{ translate("Instagram") }}</th>
                    <td class="font-weight-normal">
                        <a
                            :href="'https://instagram.com/' +
                                contact_details.instagram
                                "
                            target="_blank"
                        >{{ contact_details.instagram }}
                            <i class="las la-external-link-alt"></i></a>
                    </td>
                </tr>
                <tr v-if="contact_details.tiktok">
                    <th scope="row">{{ translate("TikTok") }}</th>
                    <td class="font-weight-normal">
                        <a
                            :href="'https://tiktok.com/@' + contact_details.tiktok
                                "
                            target="_blank"
                        >{{ contact_details.tiktok }}
                            <i class="las la-external-link-alt"></i></a>
                    </td>
                </tr>
                <tr v-if="contact_details.facebook">
                    <th scope="row">{{ translate("Facebook") }}</th>
                    <td class="font-weight-normal">
                        <a
                            :href="contact_details.facebook"
                            target="_blank"
                        >{{ contact_details.facebook }}
                            <i class="las la-external-link-alt"></i></a>
                    </td>
                </tr>
                <tr v-if="contact_details.twitter">
                    <th scope="row">{{ translate("X") }}</th>
                    <td class="font-weight-normal">
                        <a
                            :href="'https://x.com/' + contact_details.twitter"
                            target="_blank"
                        >{{ contact_details.twitter }}
                            <i class="las la-external-link-alt"></i></a>
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ translate("Country") }}</th>
                    <td class="font-weight-normal">
                        {{ contact_details.country_name }}
                    </td>
                </tr>
            </tbody>
        </table>
    </modal>
</template>

<script>
import PersonSvg from "@/svg/PersonSvg.vue";

export default {
    components: { PersonSvg },

    props: ["contact_details", "submission_id"],

    methods: {
        openAuthorContactDetailsModal() {
            jQuery("#dm-author-contact-details-modal-" + this.submission_id).modal();
        },
    },
};
</script>
